import { ModItemCategoryType } from "../../models/enums";
import { ModTierType } from "../../models/item-data-models";

export const modTierData: Partial<Record<ModItemCategoryType, { tier: ModTierType; prefixes?: string; suffixes: string }[]>> = {
  "Attack Amulets": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Athlete's|Confident|Countess'|Hoarder's|Hunter's|Impregnable|Incandescent|Mirage's|Ranger's|Scintillating|Unassailable|Virile",
      "suffixes": "of Archaeology|of Bameth|of Battle|of Destruction|of Ephij|of Fleshbinding|of Haast|of Magma|of Tzteosh|of Unmaking|of Zen|of the Ice|of the Infinite|of the Jaguar|of the Leviathan|of the Lightning|of the Multiverse|of the Phantom|of the Savant|of the Span|of the Titan|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Collector's|Dauntless|Dazzling|Girded|Indomitable|Marchioness'|Nightmare's|Optimistic|Phantasm's|Rotund|Steady|Thickened",
      "suffixes": "of Calamity|of Dueling|of Exile|of Expulsion|of Ferocity|of Fury|of Raiding|of Ruin|of Serenity|of Suturing|of Variegation|of the Goliath|of the Leopard|of the Maelstrom|of the Polar Bear|of the Rainbow|of the Sage|of the Universe|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Adept's|Apprentice's|Focused|Glimmering|Glittering|Hale|Healthy|Occultist's|Precise|Professor's|Protective|Reinforced|Reliable|Sanguine|Scholar's|Shade's|Shining",
      "suffixes": "of Convalescence|of Expertise|of Ire|of Legerdemain|of Menace|of Nimbleness|of Recuperation|of Sortilege|of Talent|of the Bear|of the Brute|of the Cloud|of the Clouds|of the Crystal|of the Drake|of the Enchanter|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mage|of the Meteor|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Sky|of the Sorcerer|of the Squall|of the Starfish|of the Storm|of the Student|of the Troll|of the Whelpling|of the Wrestler"
    }
  ],
  "Attack Rings": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Adroit|Blasting|Cremating|Crystalline|Discharging|Electrocuting|Elusory|Entombing|Flaring|Hoarder's|Hunter's|Magmatic|Polar|Ranger's|Rotund|Smiting|Tempered|Vile|Virile",
      "suffixes": "of Archaeology|of Bameth|of Ephij|of Haast|of Magma|of Tzteosh|of the Arid|of the Comet|of the Ice|of the Jaguar|of the Leviathan|of the Lightning|of the Phantom|of the Rainbow|of the Remora|of the Savant|of the Titan|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Cauterising|Collector's|Coursing|Darkened|Glaciated|Hailing|Incinerating|Malignant|Razor-sharp|Robust|Shocking|Snowy|Steady|Striking|Vaporous|Volcanic",
      "suffixes": "of Exile|of Expulsion|of Raiding|of Variegation|of the Goliath|of the Leopard|of the Locust|of the Maelstrom|of the Meteor|of the Parched|of the Polar Bear|of the Sage|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Acrobat's|Agile|Bitter|Burnished|Buzzing|Charged|Chilled|Dancer's|Focused|Frosted|Glinting|Hale|Healthy|Heated|Humming|Icy|Impure|Polished|Precise|Reliable|Sanguine|Searing|Smoking|Smouldering|Snapping",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Enveloping|of Expertise|of Infusion|of Nimbleness|of Osmosis|of Sortilege|of Success|of Talent|of Triumph|of Vanquishing|of Victory|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Squall|of the Starfish|of the Storm|of the Student|of the Troll|of the Whelpling|of the Wrestler"
    }
  ],
  "Belts": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Abating|Athlete's|Chalybeous|Fecund|Gentian|Inspiring|Regenerating|Unmoving",
      "suffixes": "of Bameth|of Ephij|of Haast|of Magma|of Tzteosh|of the Gods|of the Ice|of the Lightning|of the Titan"
    },
    {
      "tier": "Good",
      "prefixes": "Enveloped|Exciting|Galvanizing|Opalescent|Refreshing|Rejuvenating|Virile",
      "suffixes": "of Exile|of Expulsion|of the Leviathan|of the Maelstrom|of the Polar Bear|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Affecting|Azure|Barbed|Beryl|Cobalt|Edged|Hale|Healthy|Jagged|Lacquered|Pointed|Restoring|Ribbed|Sanguine|Spiked|Spiny|Studded|Thorny",
      "suffixes": "of Convalescence|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Hydra|of the Lizard|of the Lost|of the Narwhal|of the Newt|of the Penguin|of the Salamander|of the Seal|of the Squall|of the Starfish|of the Storm|of the Troll|of the Whelpling|of the Wrestler"
    }
  ],
  "Caster Amulets": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": "of the Sorcerer"
    },
    {
      "tier": "Great",
      "prefixes": "Athlete's|Calculating|Confident|Countess'|Dooming|Enervating|Glyphic|Hoarder's|Incandescent|Incanter's|Ingenious|Mnemonic|Passionate|Runic|Scintillating|Ultramarine|Unassailable|Virile|Zaffre",
      "suffixes": "of Archaeology|of Bameth|of Destruction|of Ephij|of Haast|of Jordan|of Magma|of Nirvana|of Prestidigitation|of Tzteosh|of Understanding|of Unmaking|of the Enchanter|of the Ice|of the Infinite|of the Leviathan|of the Lightning|of the Multiverse|of the Savant|of the Sharpshooter|of the Span|of the Titan|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Astute|Blue|Collector's|Dauntless|Dazzling|Exhausting|Indomitable|Maledicting|Marchioness'|Mazarine|Occultist's|Optimistic|Perceptive|Professor's|Rotund|Sagacious|Spirited|Trailblazing",
      "suffixes": "of Bliss|of Calamity|of Euphoria|of Exile|of Experimentation|of Expulsion|of Ferocity|of Fury|of Legerdemain|of Raiding|of Ruin|of Sortilege|of Variegation|of the Fletcher|of the Goliath|of the Maelstrom|of the Mage|of the Polar Bear|of the Rainbow|of the Sage|of the Universe|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Adept's|Apprentice's|Azure|Beryl|Cobalt|Consistent|Deliberate|Focused|Glimmering|Glittering|Hale|Healthy|Precise|Protective|Reliable|Sanguine|Scholar's|Shining|Steady|Teal|Thoughtful",
      "suffixes": "of Battle|of Combat|of Convalescence|of Dueling|of Excitement|of Ire|of Menace|of Recuperation|of Talent|of the Bear|of the Brute|of the Cloud|of the Clouds|of the Crystal|of the Drake|of the Flatworm|of the Hydra|of the Lizard|of the Lost|of the Meteor|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Sky|of the Squall|of the Starfish|of the Storm|of the Student|of the Troll|of the Whelpling|of the Wrestler"
    }
  ],
  "Caster Belts": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Athlete's|Chalybeous|Enervating|Fecund|Gentian|Incandescent|Ingenious|Inspiring|Scintillating",
      "suffixes": "of Bameth|of Ephij|of Haast|of Magma|of Nirvana|of Tzteosh|of the Gods|of the Ice|of the Lightning|of the Titan"
    },
    {
      "tier": "Good",
      "prefixes": "Dazzling|Exciting|Exhausting|Galvanizing|Opalescent|Trailblazing|Virile",
      "suffixes": "of Bliss|of Euphoria|of Exile|of Expulsion|of the Leviathan|of the Maelstrom|of the Polar Bear|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Affecting|Azure|Beryl|Cobalt|Glimmering|Glittering|Hale|Healthy|Sanguine|Shining",
      "suffixes": "of Convalescence|of Excitement|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Hydra|of the Lizard|of the Lost|of the Narwhal|of the Newt|of the Penguin|of the Salamander|of the Seal|of the Squall|of the Starfish|of the Storm|of the Troll|of the Whelpling|of the Wrestler"
    }
  ],
  "Caster Jewels": [
    {
      "tier": "Great",
      "prefixes": "Focusing|Mystic|Prismatic|Shimmering",
      "suffixes": "of Annihilating|of Annihilation|of Enchanting|of Potency|of Unmaking"
    },
    {
      "tier": "Good",
      "prefixes": "Acrimonious|Bestial|Blasting|Chaotic|Chilling|Numbing|Serene",
      "suffixes": "of Energy|of Freezing|of Osmosis|of Shocking|of the Wild"
    },
    {
      "tier": "Bad",
      "prefixes": "",
      "suffixes": ""
    }
  ],
  "Caster Rings": [
    {
      "tier": "Perfect",
      "prefixes": "Hoarder's",
      "suffixes": "of Archaeology|of Destruction|of Jordan|of Unmaking"
    },
    {
      "tier": "Great",
      "prefixes": "Blue|Calculating|Collector's|Dooming|Passionate|Rotund|Virile|Zaffre",
      "suffixes": "of Bameth|of Ephij|of Ferocity|of Haast|of Legerdemain|of Magma|of Nirvana|of Raiding|of Ruin|of Tzteosh|of Understanding|of the Comet|of the Hearth|of the Ice|of the Leviathan|of the Lightning|of the Rainbow|of the Savant|of the Titan|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Astute|Chalybeous|Magpie's|Maledicting|Mazarine|Robust|Sagacious|Spirited",
      "suffixes": "of Bliss|of Calamity|of Euphoria|of Exile|of Experimentation|of Expulsion|of Fury|of Kindling|of Plunder|of Sortilege|of Variegation|of the Goliath|of the Maelstrom|of the Meteor|of the Polar Bear|of the Sage|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Azure|Beryl|Cobalt|Hale|Healthy|Sanguine|Teal|Thoughtful",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Enveloping|of Excitement|of Infusion|of Ire|of Menace|of Osmosis|of Success|of Triumph|of Vanquishing|of Victory|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Hydra|of the Lizard|of the Lost|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Squall|of the Starfish|of the Storm|of the Student|of the Troll|of the Whelpling|of the Wrestler"
    }
  ],
  "Caster Time-Lost Jewels": [
    {
      "tier": "Great",
      "prefixes": "Focusing|Grand|Greater|Mystic|Prismatic|Shimmering",
      "suffixes": "of Annihilating|of Annihilation|of Enchanting|of Potency|of Unmaking"
    },
    {
      "tier": "Good",
      "prefixes": "Acrimonious|Bestial|Blasting|Chaotic|Chilling|Numbing|Serene",
      "suffixes": "of Energy|of Freezing|of Osmosis|of Shocking|of the Wild"
    },
    {
      "tier": "Bad",
      "prefixes": "",
      "suffixes": ""
    }
  ],
  "Chaos": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Glyphic|Lich's|Malevolent|Runic|Twisted",
      "suffixes": "of Armageddon|of Destruction|of Finesse|of Unmaking|of the Enchanter|of the Sorcerer|of the Wizard"
    },
    {
      "tier": "Good",
      "prefixes": "Archmage's|Incanter's|Mage's|Vile",
      "suffixes": "of Calamity|of Ferocity|of Fury|of Havoc|of Legerdemain|of Prestidigitation|of Ruin|of the Evoker|of the Mage"
    },
    {
      "tier": "Bad",
      "prefixes": "Adept's|Agonising|Alpine|Apprentice's|Arctic|Ardent|Biting|Bitter|Blistering|Bolting|Caster's|Cauterising|Charged|Clouded|Coursing|Deadly|Destructive|Electrifying|Fanatic's|Fatal|Fervent|Hailing|Hissing|Impure|Infernal|Lethal|Magmatic|Malicious|Malignant|Pernicious|Pitiless|Punishing|Ruthless|Sadistic|Scholar's|Searing|Sizzling|Smiting|Smoldering|Snowy|Striking|Tainted|Unforgiving|Vengeful|Vorpal|Zealot's",
      "suffixes": "of Absorption|of Agony|of Bleakness|of Cinders|of Coals|of Combustion|of Conquest|of Consumption|of Desolation|of Electricity|of Electrocution|of Enveloping|of Flames|of Freezing|of Ice|of Ignition|of Immolation|of Incineration|of Infusion|of Ire|of Menace|of Osmosis|of Rime|of Scorching|of Shocking|of Siphoning|of Sleet|of Snow|of Sparks|of Static|of Success|of Suffering|of Talent|of Torment|of Triumph|of Valour|of Vanquishing|of Victory|of Voltage|of Voltages|of Zapping|of the Apt|of the Glacier|of the Hyperboreal|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "Cold": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Cryomancer's|Crystalline|Frostbound|Glyphic|Lich's|Runic",
      "suffixes": "of Destruction|of Finesse|of Frostbite|of Unmaking|of the Arctic|of the Enchanter|of the Sorcerer|of the Wizard"
    },
    {
      "tier": "Good",
      "prefixes": "Archmage's|Arctic|Incanter's|Mage's|Malicious|Ruthless",
      "suffixes": "of Calamity|of Ferocity|of Fury|of Legerdemain|of Prestidigitation|of Rime|of Ruin|of the Evoker|of the Hyperboreal|of the Mage"
    },
    {
      "tier": "Bad",
      "prefixes": "Adept's|Agonising|Alpine|Apprentice's|Ardent|Biting|Bitter|Blistering|Bolting|Caster's|Cauterising|Charged|Clouded|Coursing|Darkened|Deadly|Electrifying|Fanatic's|Fatal|Fervent|Hissing|Impure|Infernal|Lethal|Magmatic|Malignant|Pitiless|Punishing|Sadistic|Scholar's|Searing|Sizzling|Smiting|Smoldering|Striking|Tainted|Unforgiving|Vengeful|Vile|Vorpal|Zealot's",
      "suffixes": "of Absorption|of Agony|of Anarchy|of Cinders|of Coals|of Combustion|of Conquest|of Consumption|of Desolation|of Electricity|of Electrocution|of Enveloping|of Flames|of Havoc|of Ignition|of Immolation|of Incineration|of Infusion|of Ire|of Menace|of Osmosis|of Scorching|of Shocking|of Siphoning|of Sparks|of Static|of Success|of Suffering|of Talent|of Torment|of Triumph|of Turmoil|of Valour|of Vanquishing|of Victory|of Voltage|of Voltages|of Zapping|of the Apt|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "ES Body Armours": [
    {
      "tier": "Perfect",
      "prefixes": "Resplendent|Unfaltering",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Apparition's|Banshee's|Divine|Duchess'|Godly|Grand|Illusion's|Illusory|Impenetrable|Incandescent|Incorporeal|Indomitable|Inspired|Interpermeated|Princess'|Queen's|Saintly|Scintillating|Stalker's|Unassailable|Victor's",
      "suffixes": "of Bameth|of Ephij|of Haast|of Magma|of Suffusion|of Thermokryptance|of Tzteosh|of Warping|of the Ice|of the Lightning|of the Savant|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Archon's|Consecrated|Countess'|Crusader's|Dauntless|Dazzling|Eidolon's|High Priest's|Interpolated|Paladin's|Phantom's|Rogue's|Unreal",
      "suffixes": "of Ardour|of Diversion|of Exile|of Expulsion|of Flexure|of Furring|of Padding|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Sage|of the Titan|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Abbot's|Anointed|Athlete's|Augur's|Auspex's|Barbed|Bard's|Baronness'|Bishop's|Blessed|Deacon's|Druid's|Edged|Ethereal|Exarch's|Faithful|Fecund|Glimmering|Glittering|Glowing|Hale|Haruspex's|Healthy|Infixed|Ingrained|Instilled|Jagged|Lady's|Minstrel's|Monk's|Musician's|Nymph's|Poet's|Pointed|Prior's|Protective|Pursuer's|Resolute|Robust|Rotund|Sanctified|Sanguine|Shadowy|Shining|Spiked|Spiny|Stalwart|Stout|Strong-Willed|Sylph's|Thorny|Troubadour's|Unworldly|Vigorous|Virile|Visionary's|Will-o-wisp's",
      "suffixes": "of Convalescence|of Covering|of Deflecting|of Recuperation|of Resurgence|of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Starfish|of the Storm|of the Student|of the Talented|of the Troll|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "ES Boots": [
    {
      "tier": "Perfect",
      "prefixes": "Blazing|Hellion's|Unassailable",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Cheetah's|Cherub's|Hallowed|Illusory|Indomitable|Inspired|Pulsing",
      "suffixes": "of Archaeology|of Bameth|of Buffering|of Ephij|of Flexure|of Furring|of Haast|of Magma|of Tzteosh|of the Ice|of the Lightning|of the Savant|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Dauntless|Evanescent|Gazelle's|Inculcated|Interpolated|Radiating|Sanctified|Sylph's|Unreal",
      "suffixes": "of Diversion|of Exile|of Expulsion|of Padding|of Raiding|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Sage|of the Titan|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Hale|Healthy|Infixed|Protective|Robust|Rotund|Runner's|Sanguine|Shadowy|Shining|Stalwart|Stout",
      "suffixes": "of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Starfish|of the Storm|of the Student|of the Talented|of the Troll|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "ES Gloves": [
    {
      "tier": "Perfect",
      "prefixes": "Blazing|Unassailable",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Amazon's|Blasting|Chalybeous|Cherub's|Cremating|Discharging|Electrocuting|Entombing|Flaring|Gentian|Hallowed|Illusory|Indomitable|Inspired|Polar|Pulsing|Ranger's|Tempered",
      "suffixes": "of Archaeology|of Bameth|of Buffering|of Dueling|of Ephij|of Flexure|of Furring|of Haast|of Magma|of Renown|of Tzteosh|of the Desperate|of the Ice|of the Lightning|of the Savant|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Dauntless|Evanescent|Glaciated|Hunter's|Incinerating|Inculcated|Interpolated|Opalescent|Radiating|Razor-sharp|Sanctified|Shocking|Sylph's|Unreal",
      "suffixes": "of Combat|of Diversion|of Exile|of Expulsion|of Mastery|of Padding|of Raiding|of the Drought|of the Goliath|of the Jaguar|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Sage|of the Titan|of the Volcano|of the Wind"
    },
    {
      "tier": "Bad",
      "prefixes": "Abbot's|Augur's|Auspex's|Azure|Bard's|Beryl|Bishop's|Burnished|Buzzing|Chilled|Cobalt|Druid's|Exarch's|Focused|Frosted|Glinting|Hale|Haruspex's|Healthy|Heated|Humming|Icy|Infixed|Minstrel's|Monk's|Musician's|Poet's|Polished|Precise|Prior's|Protective|Reliable|Robust|Rotund|Sanguine|Shadowy|Shining|Smoking|Smouldering|Snapping|Stalwart|Stout|Troubadour's|Visionary's",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Enveloping|of Infusion|of Osmosis|of Regrowth|of Rejuvenation|of Restoration|of Siphoning|of Success|of Triumph|of Valour|of Vanquishing|of Victory|of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Fox|of the Lamprey|of the Locust|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Penguin|of the Prodigy|of the Pupil|of the Remora|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Storm|of the Student|of the Talented|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "ES Helmets": [
    {
      "tier": "Perfect",
      "prefixes": "Dazzling|Unassailable",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Amazon's|Angel's|Beatified|Blazing|Falcon's|Hoarder's|Illusory|Indomitable|Inspired|Pulsing|Ranger's|Spirit's|Whale's",
      "suffixes": "of Archaeology|of Bameth|of Buffering|of Ephij|of Flexure|of Furring|of Haast|of Magma|of Tzteosh|of the Genius|of the Ice|of the Lightning|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Celestial|Cherub's|Collector's|Dauntless|Dolphin's|Eagle's|Evanescent|Hallowed|Hawk's|Heavenly|Hunter's|Inculcated|Interpolated|Orca's|Radiating|Unreal",
      "suffixes": "of Diversion|of Exile|of Expulsion|of Padding|of Raiding|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Savant|of the Titan|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Abbot's|Augur's|Auspex's|Bard's|Bishop's|Coelacanth's|Druid's|Exarch's|Focused|Glimmering|Glittering|Hale|Haruspex's|Healthy|Imbued|Infixed|Minstrel's|Monk's|Musician's|Poet's|Precise|Prior's|Protective|Reliable|Robust|Rotund|Sanguine|Shadowy|Shining|Stalwart|Stout|Troubadour's|Virile|Visionary's|Vulture's",
      "suffixes": "of Light|of Radiance|of Shining|of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Starfish|of the Storm|of the Student|of the Talented|of the Troll|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "ES Shields": [
    {
      "tier": "Perfect",
      "prefixes": "Incandescent|Unfaltering",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Adamant|Agonising|Apparition's|Arctic|Dazzling|Illusion's|Illusory|Impenetrable|Incanter's|Incorporeal|Indomitable|Inspired|Interpermeated|Magmatic|Saintly|Scintillating|Smiting|Unassailable|Victor's|Vile",
      "suffixes": "of Bameth|of Ephij|of Ferocity|of Haast|of Harmony|of Magma|of Prestidigitation|of Ruin|of Suffusion|of Thermokryptance|of Tzteosh|of Warping|of the Enchanter|of the Everlasting|of the Ice|of the Lightning|of the Lightning Rod|of the Mammoth|of the Savant|of the Solar Storm|of the Span|of the Virtuoso"
    },
    {
      "tier": "Good",
      "prefixes": "Beatified|Blazing|Cauterising|Consecrated|Coursing|Darkened|Dauntless|Eidolon's|Hailing|Interpolated|Malignant|Occultist's|Pitiless|Professor's|Sadistic|Smoldering|Snowy|Spirit's|Striking|Unreal|Unrelenting",
      "suffixes": "of Ardour|of Calamity|of Concord|of Diversion|of Exile|of Expulsion|of Flexure|of Furring|of Fury|of Legerdemain|of Padding|of Shockproofing|of Sortilege|of Variegation|of the Deathless|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Mage|of the Molten Core|of the Phantom|of the Polar Bear|of the Rainbow|of the Sage|of the Titan|of the Tundra|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Apprentice's|Athlete's|Barbed|Bitter|Blessed|Charged|Edged|Ethereal|Glimmering|Glittering|Hale|Healthy|Impure|Infixed|Ingrained|Instilled|Jagged|Pointed|Protective|Punishing|Resolute|Robust|Rotund|Sanguine|Searing|Shadowy|Shining|Spiked|Spiny|Stalwart|Stout|Strong-Willed|Thorny|Unworldly|Virile|Will-o-wisp's",
      "suffixes": "of Covering|of Deflecting|of Talent|of the Apt|of the Bear|of the Brute|of the Cloud|of the Crystal|of the Drake|of the Fox|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Storm|of the Student|of the Talented|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "Fire": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Flamebound|Glyphic|Lich's|Pyromancer's|Runic|Volcanic",
      "suffixes": "of Conflagration|of Destruction|of Finesse|of Inferno|of Unmaking|of the Enchanter|of the Sorcerer|of the Wizard"
    },
    {
      "tier": "Good",
      "prefixes": "Archmage's|Incanter's|Infernal|Mage's|Magmatic|Zealot's",
      "suffixes": "of Calamity|of Combustion|of Ferocity|of Fury|of Immolation|of Legerdemain|of Prestidigitation|of Ruin|of the Evoker|of the Mage"
    },
    {
      "tier": "Bad",
      "prefixes": "Adept's|Agonising|Alpine|Apprentice's|Arctic|Biting|Bitter|Blistering|Bolting|Caster's|Charged|Clouded|Coursing|Darkened|Deadly|Destructive|Electrifying|Fatal|Fervent|Hailing|Hissing|Impure|Lethal|Malicious|Malignant|Pernicious|Pitiless|Punishing|Ruthless|Sadistic|Scholar's|Searing|Sizzling|Smiting|Snowy|Striking|Tainted|Unforgiving|Vengeful|Vile|Vorpal",
      "suffixes": "of Absorption|of Agony|of Anarchy|of Bleakness|of Conquest|of Consumption|of Desolation|of Electricity|of Electrocution|of Enveloping|of Freezing|of Havoc|of Ice|of Infusion|of Ire|of Menace|of Osmosis|of Rime|of Shocking|of Siphoning|of Sleet|of Snow|of Sparks|of Static|of Success|of Suffering|of Talent|of Torment|of Triumph|of Turmoil|of Valour|of Vanquishing|of Victory|of Voltage|of Voltages|of Zapping|of the Apt|of the Glacier|of the Hyperboreal|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "Life Body Armours": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Adaptable|Antelope's|Apparition's|Banshee's|Centurion's|Crocodile's|Divine|Duchess'|Fugitive|Godly|Grand|Hardened|Illusion's|Illusory|Impenetrable|Impervious|Impregnable|Incandescent|Incorporeal|Inspired|Interpermeated|Legend's|Lissome|Maestro's|Mirage's|Pope's|Predator's|Prime|Princess'|Prophet's|Queen's|Rapturous|Resplendent|Saintly|Stag's|Stalker's|Unassailable|Unfaltering|Unmoving|Versatile|Victor's|Vigorous",
      "suffixes": "of Bameth|of Ephij|of Exile|of Haast|of Magma|of Suffusion|of Thermokryptance|of Tzteosh|of Warping|of the Ice|of the Lightning"
    },
    {
      "tier": "Good",
      "prefixes": "Abating|Adroit|Aggressor's|Archon's|Assailant's|Bard's|Bishop's|Caribou's|Consecrated|Countess'|Crusader's|Dazzling|Deer's|Eidolon's|Elusory|Enveloped|Exarch's|Fecund|Girded|Haruspex's|Hero's|High Priest's|Ibex's|Indomitable|Interpolated|Knight's|Minstrel's|Nautilus'|Nightmare's|Octopus'|Paladin's|Pangolin's|Phantom's|Ram's|Resilient|Rogue's|Scintillating|Shelled|Unreal|Visionary's|Warrior's",
      "suffixes": "of Ardour|of Diversion|of Expulsion|of Flexure|of Furring|of Padding|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Sage|of the Savant|of the Titan|of the Virtuoso|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Abalone's|Acrobat's|Agile|Anointed|Augur's|Barbed|Baronness'|Blessed|Brawler's|Bully's|Dancer's|Deacon's|Edged|Ethereal|Faithful|Fencer's|Flea's|Fleet|Flexible|Fortified|Ghost's|Glimmering|Glittering|Glowing|Hale|Healthy|Impala's|Infixed|Ingrained|Instilled|Jagged|Lacquered|Lady's|Layered|Lobstered|Monk's|Nymph's|Oyster's|Pliant|Poet's|Pointed|Protective|Pursuer's|Reinforced|Resolute|Ribbed|Sanctified|Sanguine|Scrapper's|Shade's|Shadowy|Shining|Spectre's|Spiked|Spiny|Strong-Willed|Studded|Supple|Swordsman's|Sylph's|Thorny|Unworldly|Will-o-wisp's",
      "suffixes": "of Convalescence|of Covering|of Deflecting|of Recuperation|of Resurgence|of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Starfish|of the Storm|of the Student|of the Talented|of the Troll|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "Life Boots": [
    {
      "tier": "Perfect",
      "prefixes": "Hellion's",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Athlete's|Blazing|Cheetah's|Cherub's|Durable|Encased|Hallowed|Illusory|Impregnable|Inspired|Legend's|Mirage's|Rotund|Unassailable|Vaporous|Virile",
      "suffixes": "of Archaeology|of Bameth|of Buffering|of Ephij|of Exile|of Flexure|of Furring|of Haast|of Magma|of Tzteosh|of the Ice|of the Lightning"
    },
    {
      "tier": "Good",
      "prefixes": "Blurred|Carapaced|Dauntless|Duelist's|Evanescent|Flexible|Gazelle's|Girded|Hero's|Inculcated|Indomitable|Interpolated|Nightmare's|Phantasm's|Phased|Plated|Pulsing|Radiating|Robust|Sanctified|Sylph's|Thickened|Unreal",
      "suffixes": "of Diversion|of Expulsion|of Padding|of Raiding|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Sage|of the Savant|of the Titan|of the Virtuoso|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Agile|Hale|Healthy|Infixed|Lacquered|Protective|Reinforced|Runner's|Scrapper's|Shade's|Shadowy|Shining",
      "suffixes": "of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Starfish|of the Storm|of the Student|of the Talented|of the Troll|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "Life Gloves": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Amazon's|Athlete's|Blasting|Blazing|Chalybeous|Cherub's|Cremating|Crocodile's|Discharging|Durable|Electrocuting|Encased|Entombing|Flaring|Gentian|Hallowed|Illusory|Impregnable|Inspired|Legend's|Maestro's|Mirage's|Polar|Pope's|Predator's|Prophet's|Ranger's|Rotund|Stag's|Tempered|Unassailable|Vaporous|Virile",
      "suffixes": "of Archaeology|of Bameth|of Buffering|of Dueling|of Ephij|of Exile|of Ferocity|of Flexure|of Furring|of Haast|of Magma|of Renown|of Tzteosh|of the Desperate|of the Ice|of the Lightning|of the Vampire"
    },
    {
      "tier": "Good",
      "prefixes": "Aggressor's|Assailant's|Bard's|Bishop's|Blurred|Carapaced|Dauntless|Duelist's|Evanescent|Exarch's|Flexible|Girded|Glaciated|Haruspex's|Hero's|Hunter's|Ibex's|Incinerating|Inculcated|Indomitable|Interpolated|Minstrel's|Nautilus'|Nightmare's|Octopus'|Opalescent|Phantasm's|Phased|Plated|Pulsing|Radiating|Ram's|Razor-sharp|Robust|Sanctified|Shocking|Sylph's|Thickened|Unreal|Visionary's",
      "suffixes": "of Combat|of Diversion|of Expulsion|of Fury|of Mastery|of Padding|of Raiding|of the Drought|of the Goliath|of the Jaguar|of the Lamprey|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Sage|of the Savant|of the Titan|of the Virtuoso|of the Volcano|of the Wind"
    },
    {
      "tier": "Bad",
      "prefixes": "Agile|Augur's|Azure|Beryl|Bully's|Burnished|Buzzing|Chilled|Cobalt|Flea's|Focused|Frosted|Glinting|Hale|Healthy|Heated|Humming|Icy|Infixed|Lacquered|Monk's|Oyster's|Poet's|Polished|Precise|Protective|Reinforced|Reliable|Scrapper's|Shade's|Shadowy|Shining|Smoking|Smouldering|Snapping",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Enveloping|of Infusion|of Osmosis|of Regrowth|of Rejuvenation|of Restoration|of Siphoning|of Success|of Triumph|of Valour|of Vanquishing|of Victory|of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Fox|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Storm|of the Student|of the Talented|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "Life Helmets": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Amazon's|Ancestral|Angel's|Athlete's|Beatified|Blazing|Cerberus'|Crocodile's|Dazzling|Elusory|Encased|Enveloped|Falcon's|Fecund|Hoarder's|Illusory|Impregnable|Inspired|Legend's|Maestro's|Mirage's|Pope's|Predator's|Prophet's|Ranger's|Spirit's|Stag's|Sturdy|Unassailable|Vaporous|Virile|Wanderer's|Whale's",
      "suffixes": "of Archaeology|of Bameth|of Buffering|of Ephij|of Exile|of Flexure|of Furring|of Haast|of Magma|of Tzteosh|of the Ice|of the Lightning"
    },
    {
      "tier": "Good",
      "prefixes": "Aggressor's|Assailant's|Bard's|Bishop's|Bull's|Carapaced|Celestial|Cherub's|Chieftain's|Collector's|Colossal|Dauntless|Dolphin's|Duelist's|Durable|Eagle's|Evanescent|Exarch's|Explorer's|Girded|Hallowed|Haruspex's|Hawk's|Heavenly|Hero's|Hunter's|Ibex's|Inculcated|Indomitable|Interpolated|Minotaur's|Minstrel's|Nautilus'|Nightmare's|Octopus'|Orca's|Phantasm's|Phased|Pulsing|Ram's|Rotund|Thickened|Unreal|Visionary's|Wayfarer's",
      "suffixes": "of Diversion|of Expulsion|of Padding|of Raiding|of the Genius|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Phantom|of the Polar Bear|of the Savant|of the Titan|of the Virtuoso|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Acrobat's|Agile|Augur's|Bully's|Coelacanth's|Dancer's|Flea's|Focused|Glimmering|Glittering|Hale|Healthy|Imbued|Imposing|Infixed|Lacquered|Monk's|Nomad's|Oyster's|Poet's|Precise|Protective|Reinforced|Reliable|Rhoa's|Ribbed|Scrapper's|Shade's|Shadowy|Shining|Studded|Vulture's",
      "suffixes": "of Light|of Radiance|of Shining|of the Apt|of the Bear|of the Brute|of the Cloud|of the Drake|of the Flatworm|of the Fox|of the Hydra|of the Lizard|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Newt|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Starfish|of the Storm|of the Student|of the Talented|of the Troll|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "Life Shields": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Abating|Adamant|Adaptable|Adroit|Apparition's|Athlete's|Fecund|Illusion's|Illusory|Impenetrable|Impregnable|Incandescent|Incorporeal|Inspired|Interpermeated|Legend's|Lissome|Mirage's|Saintly|Scintillating|Unfaltering|Unmoving|Victor's|Vigorous",
      "suffixes": "of Bameth|of Ephij|of Exile|of Haast|of Harmony|of Magma|of Suffusion|of Thermokryptance|of Tzteosh|of Warping|of the Conservator|of the Everlasting|of the Ice|of the Lightning|of the Lightning Rod|of the Mammoth|of the Solar Storm|of the Span"
    },
    {
      "tier": "Good",
      "prefixes": "Beatified|Consecrated|Dazzling|Eidolon's|Elusory|Enveloped|Girded|Hero's|Interpolated|Nightmare's|Resilient|Spirit's|Sturdy|Unreal|Unrelenting|Virile",
      "suffixes": "of Ardour|of Concord|of Diversion|of Expulsion|of Flexure|of Furring|of Padding|of Shockproofing|of Variegation|of the Deathless|of the Goliath|of the Jaguar|of the Leopard|of the Leviathan|of the Maelstrom|of the Molten Core|of the Phantom|of the Polar Bear|of the Protector|of the Rainbow|of the Sage|of the Savant|of the Titan|of the Tundra|of the Virtuoso|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Acrobat's|Agile|Barbed|Blessed|Brawler's|Dancer's|Edged|Ethereal|Fencer's|Ghost's|Glimmering|Glittering|Hale|Healthy|Infixed|Ingrained|Instilled|Jagged|Lacquered|Layered|Lobstered|Pointed|Reinforced|Ribbed|Sanguine|Scrapper's|Shade's|Shadowy|Shining|Spectre's|Spiked|Spiny|Studded|Supple|Thorny|Unworldly|Will-o-wisp's",
      "suffixes": "of Covering|of Deflecting|of the Apt|of the Bear|of the Brute|of the Cloud|of the Crystal|of the Drake|of the Fox|of the Lost|of the Lynx|of the Mongoose|of the Narwhal|of the Penguin|of the Prodigy|of the Pupil|of the Salamander|of the Seal|of the Skilled|of the Squall|of the Storm|of the Student|of the Talented|of the Whelpling|of the Worthy|of the Wrestler"
    }
  ],
  "Lightning": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Electromancer's|Glyphic|Ionising|Lich's|Runic|Stormbound",
      "suffixes": "of Destruction|of Finesse|of Thunder|of Unmaking|of the Enchanter|of the Sorcerer|of the Thunderbolt|of the Wizard"
    },
    {
      "tier": "Good",
      "prefixes": "Archmage's|Electrifying|Incanter's|Mage's|Smiting|Vorpal",
      "suffixes": "of Calamity|of Ferocity|of Fury|of Legerdemain|of Prestidigitation|of Ruin|of Voltage|of Voltages|of the Evoker|of the Mage"
    },
    {
      "tier": "Bad",
      "prefixes": "Adept's|Agonising|Alpine|Apprentice's|Arctic|Ardent|Biting|Bitter|Blistering|Bolting|Caster's|Cauterising|Charged|Clouded|Darkened|Deadly|Destructive|Fanatic's|Fervent|Hailing|Hissing|Impure|Infernal|Magmatic|Malicious|Malignant|Pernicious|Pitiless|Punishing|Ruthless|Sadistic|Scholar's|Searing|Sizzling|Smoldering|Snowy|Tainted|Unforgiving|Vengeful|Vile|Zealot's",
      "suffixes": "of Absorption|of Agony|of Anarchy|of Bleakness|of Cinders|of Coals|of Combustion|of Conquest|of Consumption|of Desolation|of Enveloping|of Flames|of Freezing|of Havoc|of Ice|of Ignition|of Immolation|of Incineration|of Infusion|of Ire|of Menace|of Osmosis|of Rime|of Scorching|of Siphoning|of Sleet|of Snow|of Success|of Suffering|of Talent|of Torment|of Triumph|of Turmoil|of Valour|of Vanquishing|of Victory|of the Apt|of the Glacier|of the Hyperboreal|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "Melee Jewels": [
    {
      "tier": "Great",
      "prefixes": "Armoured|Clashing|Combat|Prismatic",
      "suffixes": ""
    },
    {
      "tier": "Good",
      "prefixes": "Bestial|Blasting|Flaming|Searing|Sharpened|Shielding",
      "suffixes": "of Frenzy|of Lengthening|of Raging|of Regeneration|of the Wild"
    },
    {
      "tier": "Bad",
      "prefixes": "Fortuitous|Retaliating",
      "suffixes": "of Ancestry"
    }
  ],
  "Melee Physical": [
    {
      "tier": "Perfect",
      "prefixes": "Flaring|Merciless",
      "suffixes": "of Celebration|of Unmaking"
    },
    {
      "tier": "Great",
      "prefixes": "Cruel|Dictator's|Emperor's|Razor-sharp|Tempered|Tyrannical",
      "suffixes": "of Destruction|of Fame|of Infamy|of Ruin|of War"
    },
    {
      "tier": "Good",
      "prefixes": "Annealed|Blasting|Bloodthirsty|Carbonising|Conqueror's|Cremating|Crystalising|Devastating|Discharging|Electrocuting|Entombing|Overpowering|Polar|Unleashed|Vapourising",
      "suffixes": "of Acclaim|of Battle|of Calamity|of Ferocity|of Fury|of the Desperate|of the Drought|of the Lamprey|of the Vampire"
    },
    {
      "tier": "Bad",
      "prefixes": "Burnished|Buzzing|Catalysing|Chilled|Frosted|Glinting|Heated|Heavy|Humming|Icy|Journeyman's|Polished|Reaver's|Serrated|Smoking|Smouldering|Snapping|Squire's|Wicked",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Dazing|of Ease|of Enveloping|of Impact|of Infusion|of Ire|of Mastery|of Menace|of Osmosis|of Regrowth|of Rejuvenation|of Restoration|of Siphoning|of Skill|of Slamming|of Staggering|of Stunning|of Success|of Triumph|of Valour|of Vanquishing|of Victory|of the Apt|of the Concussion|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "Melee Time-Lost Jewels": [
    {
      "tier": "Great",
      "prefixes": "Armoured|Clashing|Combat|Grand|Greater|Prismatic",
      "suffixes": ""
    },
    {
      "tier": "Good",
      "prefixes": "Bestial|Blasting|Flaming|Searing|Sharpened|Shielding",
      "suffixes": "of Frenzy|of Lengthening|of Raging|of Regeneration|of the Wild"
    },
    {
      "tier": "Bad",
      "prefixes": "Fortuitous|Retaliating",
      "suffixes": "of Ancestry"
    }
  ],
  "Minion": [
    {
      "tier": "Perfect",
      "prefixes": "Empowering|Flaring|King's",
      "suffixes": "of the Slavedriver"
    },
    {
      "tier": "Great",
      "prefixes": "Blasting|Cremating|Discharging|Duke's|Electrocuting|Entombing|Inspirational|Motivating|Polar|Prince's|Razor-sharp|Tempered",
      "suffixes": "of Destruction|of Immortality|of Renown|of Resurgence|of Sortilege|of Unmaking|of the Overseer|of the Rector"
    },
    {
      "tier": "Good",
      "prefixes": "Annealed|Count's|Glaciated|Incinerating|Persuasive|Shocking",
      "suffixes": "of Calamity|of Expertise|of Ferocity|of Fury|of Mastery|of Recuperation|of Ruin|of the Administrator|of the Despot|of the Headmaster"
    },
    {
      "tier": "Bad",
      "prefixes": "Agitative|Baron's|Burnished|Buzzing|Chilled|Coercive|Frosted|Glinting|Heated|Humming|Icy|Instigative|Lord's|Polished|Smoking|Smouldering|Snapping",
      "suffixes": "of Ire|of Menace|of the Apt|of the Flatworm|of the Lizard|of the Mentor|of the Newt|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "Minion Amulets": [
    {
      "tier": "Perfect",
      "prefixes": "Countess'",
      "suffixes": "of the Overseer"
    },
    {
      "tier": "Great",
      "prefixes": "Athlete's|Confident|Custodian's|Fortifying|Hoarder's|Incandescent|Manipulator's|Marchioness'|Mnemonic|Puppeteer's|Restless|Scintillating|Ultramarine|Unassailable|Virile|Zaffre",
      "suffixes": "of Adaptation|of Archaeology|of Compulsion|of Control|of Extinction|of Nirvana|of Piercing|of Seizing|of Stampeding|of the Despot"
    },
    {
      "tier": "Good",
      "prefixes": "Blue|Bolstering|Collector's|Dauntless|Dazzling|Exploiter's|Indomitable|Mazarine|Optimistic|Perceptive|Reinforcing|Rotund|Sentry's|Shepherd's|Viscountess'|Waking",
      "suffixes": "of Acclimatisation|of Bliss|of Coercion|of Conditioning|of Devastation|of Eradication|of Euphoria|of Grappling|of Lacinating|of Management|of Puncturing|of Raiding|of Snaring|of Storming|of the Taskmaster"
    },
    {
      "tier": "Bad",
      "prefixes": "Azure|Bearing|Beryl|Cobalt|Conniver's|Glimmering|Glittering|Guide's|Hale|Healthy|Hustler's|Protective|Sanguine|Schemer's|Shining|Teal",
      "suffixes": "of Clutching|of Convalescence|of Excitement|of Numbness|of Pricking|of Quashing|of Recuperation|of the Flatworm|of the Hydra|of the Lizard|of the Newt|of the Starfish|of the Troll"
    }
  ],
  "Minion Belts": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": "of the Despot"
    },
    {
      "tier": "Great",
      "prefixes": "Athlete's|Chalybeous|Custodian's|Fecund|Fortifying|Gentian|Inspiring",
      "suffixes": "of Compulsion|of Seizing|of Stampeding|of the Taskmaster"
    },
    {
      "tier": "Good",
      "prefixes": "Bolstering|Exciting|Galvanizing|Opalescent|Reinforcing|Sentry's|Shepherd's|Virile",
      "suffixes": "of Coercion|of Grappling|of Snaring|of Storming"
    },
    {
      "tier": "Bad",
      "prefixes": "Affecting|Azure|Barbed|Bearing|Beryl|Cobalt|Edged|Guide's|Hale|Healthy|Jagged|Pointed|Sanguine|Spiked|Spiny|Thorny",
      "suffixes": "of Clutching|of Convalescence|of the Flatworm|of the Hydra|of the Lizard|of the Newt|of the Starfish|of the Troll"
    }
  ],
  "Minion Jewels": [
    {
      "tier": "Great",
      "prefixes": "Authoritative|Shimmering",
      "suffixes": "of Gripping|of Marshalling|of Orchestration"
    },
    {
      "tier": "Good",
      "prefixes": "Expanding|Focusing|Hexing|Necromantic|Serene",
      "suffixes": "of Acclimatisation|of Chanting|of Continuation|of Energy|of Offering|of Righteousness"
    },
    {
      "tier": "Bad",
      "prefixes": "Bestial|Burning|Overgrown|Prismatic",
      "suffixes": "of Annihilation|of Glaciers|of Potency|of the Wild"
    }
  ],
  "Minion Rings": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": "of Extinction|of Piercing"
    },
    {
      "tier": "Great",
      "prefixes": "Blue|Hoarder's|Rotund|Virile|Zaffre",
      "suffixes": "of Adaptation|of Archaeology|of Bameth|of Ephij|of Eradication|of Haast|of Lacinating|of Magma|of Nirvana|of Tzteosh|of the Ice|of the Lightning|of the Rainbow"
    },
    {
      "tier": "Good",
      "prefixes": "Chalybeous|Collector's|Mazarine|Robust",
      "suffixes": "of Acclimatisation|of Bliss|of Conditioning|of Devastation|of Euphoria|of Exile|of Expulsion|of Puncturing|of Raiding|of Variegation|of the Maelstrom|of the Polar Bear|of the Volcano"
    },
    {
      "tier": "Bad",
      "prefixes": "Azure|Beryl|Cobalt|Hale|Healthy|Sanguine|Teal",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Enveloping|of Excitement|of Infusion|of Numbness|of Osmosis|of Pricking|of Quashing|of Success|of Triumph|of Vanquishing|of Victory|of the Cloud|of the Drake|of the Flatworm|of the Hydra|of the Lizard|of the Lost|of the Narwhal|of the Newt|of the Penguin|of the Salamander|of the Seal|of the Squall|of the Starfish|of the Storm|of the Troll|of the Whelpling"
    }
  ],
  "Minion Time-Lost Jewels": [
    {
      "tier": "Great",
      "prefixes": "Authoritative|Grand|Greater|Shimmering",
      "suffixes": "of Gripping|of Marshalling|of Orchestration"
    },
    {
      "tier": "Good",
      "prefixes": "Expanding|Focusing|Hexing|Necromantic|Serene",
      "suffixes": "of Acclimatisation|of Chanting|of Continuation|of Energy|of Offering|of Righteousness"
    },
    {
      "tier": "Bad",
      "prefixes": "Bestial|Burning|Overgrown|Prismatic",
      "suffixes": "of Annihilation|of Glaciers|of Potency|of the Wild"
    }
  ],
  "Physical Caster": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Glyphic|Lich's|Oppressor's|Runic|Torturer's",
      "suffixes": "of Destruction|of Finesse|of Grief|of Unmaking|of the Enchanter|of the Sorcerer|of the Wizard"
    },
    {
      "tier": "Good",
      "prefixes": "Agonising|Archmage's|Incanter's|Mage's",
      "suffixes": "of Calamity|of Desolation|of Ferocity|of Fury|of Legerdemain|of Prestidigitation|of Ruin|of the Evoker|of the Mage"
    },
    {
      "tier": "Bad",
      "prefixes": "Adept's|Alpine|Apprentice's|Arctic|Ardent|Biting|Bitter|Blistering|Bolting|Caster's|Cauterising|Charged|Clouded|Coursing|Darkened|Deadly|Destructive|Electrifying|Fanatic's|Fatal|Fervent|Hailing|Hissing|Impure|Infernal|Lethal|Magmatic|Malicious|Malignant|Pernicious|Punishing|Ruthless|Scholar's|Searing|Sizzling|Smiting|Smoldering|Snowy|Striking|Tainted|Unforgiving|Vengeful|Vile|Vorpal|Zealot's",
      "suffixes": "of Absorption|of Anarchy|of Bleakness|of Cinders|of Coals|of Combustion|of Conquest|of Consumption|of Electricity|of Electrocution|of Enveloping|of Flames|of Freezing|of Havoc|of Ice|of Ignition|of Immolation|of Incineration|of Infusion|of Ire|of Menace|of Osmosis|of Rime|of Scorching|of Shocking|of Siphoning|of Sleet|of Snow|of Sparks|of Static|of Success|of Talent|of Triumph|of Turmoil|of Valour|of Vanquishing|of Victory|of Voltage|of Voltages|of Zapping|of the Apt|of the Glacier|of the Hyperboreal|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "Physical Quivers": [
    {
      "tier": "Perfect",
      "prefixes": "",
      "suffixes": ""
    },
    {
      "tier": "Great",
      "prefixes": "Amazon's|Flaring|Impaling|Nimble|Ranger's|Tempered",
      "suffixes": "of Destruction|of Renown|of Splintering|of Unmaking|of the Archer"
    },
    {
      "tier": "Good",
      "prefixes": "Blasting|Cremating|Discharging|Electrocuting|Entombing|Glaciated|Hunter's|Incinerating|Incisive|Lacerating|Polar|Rapid|Razor-sharp|Shocking",
      "suffixes": "of Calamity|of Ferocity|of Fury|of Mastery|of Ruin|of Surplus"
    },
    {
      "tier": "Bad",
      "prefixes": "Acute|Burnished|Buzzing|Chilled|Focused|Frosted|Glinting|Heated|Humming|Icy|Polished|Precise|Reliable|Smoking|Smouldering|Snapping",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Enveloping|of Infusion|of Ire|of Menace|of Osmosis|of Success|of Triumph|of Vanquishing|of Victory"
    }
  ],
  "Ranged Jewels": [
    {
      "tier": "Great",
      "prefixes": "Combat|Evasive|Prismatic",
      "suffixes": "of Alacrity|of Deadliness|of Demolishing|of Speed"
    },
    {
      "tier": "Good",
      "prefixes": "Acrimonious|Archer's|Bolting|Fletching|Humming|Jolting|Monk's|Perforating|Rancorous|Slaying|Spearheaded|Surging",
      "suffixes": "of Chronomancy|of Glaciers|of Hunting|of Nocking|of Piercing|of Rapidity|of Reloading|of Sequencing|of Shocking|of Spearing"
    },
    {
      "tier": "Bad",
      "prefixes": "Engaging|Kindred|Kinship|Retreating|Soaring|Verdant",
      "suffixes": "of Biding|of Fountains|of Pathfinding|of Pinning|of Recovery|of Stoutness|of Targeting|of the Thicker|of the Woodland"
    }
  ],
  "Ranged Physical": [
    {
      "tier": "Perfect",
      "prefixes": "Flaring|Merciless",
      "suffixes": "of Acclaim|of Many|of Unmaking"
    },
    {
      "tier": "Great",
      "prefixes": "Carbonising|Cremating|Cruel|Crystalising|Dictator's|Electrocuting|Emperor's|Entombing|Razor-sharp|Tempered|Tyrannical|Vapourising",
      "suffixes": "of Destruction|of Renown|of Ruin|of Shards|of the Sniper"
    },
    {
      "tier": "Good",
      "prefixes": "Annealed|Blasting|Bloodthirsty|Conqueror's|Discharging|Polar",
      "suffixes": "of Calamity|of Ferocity|of Fury|of Mastery|of Splintering|of the Desperate|of the Drought|of the Lamprey|of the Marksman|of the Vampire"
    },
    {
      "tier": "Bad",
      "prefixes": "Burnished|Buzzing|Chilled|Frosted|Glinting|Heated|Heavy|Humming|Icy|Journeyman's|Polished|Reaver's|Serrated|Smoking|Smouldering|Snapping|Squire's|Wicked",
      "suffixes": "of Absorption|of Conquest|of Consumption|of Enveloping|of Infusion|of Ire|of Menace|of Osmosis|of Regrowth|of Rejuvenation|of Restoration|of Siphoning|of Success|of Triumph|of Valour|of Vanquishing|of Victory|of the Apt|of the Skilled|of the Talented|of the Worthy"
    }
  ],
  "Ranged Time-Lost Jewels": [
    {
      "tier": "Great",
      "prefixes": "Combat|Evasive|Grand|Greater|Prismatic",
      "suffixes": "of Alacrity|of Deadliness|of Demolishing|of Speed"
    },
    {
      "tier": "Good",
      "prefixes": "Acrimonious|Archer's|Bolting|Fletching|Humming|Jolting|Monk's|Perforating|Rancorous|Slaying|Spearheaded|Surging",
      "suffixes": "of Chronomancy|of Glaciers|of Hunting|of Nocking|of Piercing|of Rapidity|of Reloading|of Sequencing|of Shocking|of Spearing"
    },
    {
      "tier": "Bad",
      "prefixes": "Engaging|Kindred|Kinship|Retreating|Verdant",
      "suffixes": "of Biding|of Fountains|of Pathfinding|of Pinning|of Recovery|of Stoutness|of Targeting|of the Thicker|of the Woodland"
    }
  ]
}
